import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class GnMappingReportService {
  assetUrl: string

  constructor(private http: HttpClient) {
    const apiUrl = environment.apiUrl
    this.assetUrl = `${apiUrl}/assets`
  }

  getReport(params: PaginationParams, body) {
    const page = params.page
    const size = params.size
    const getUrl = `${this.assetUrl}/assets-mapped-report?page=${page}&size=${size}`
    return this.http.post<any[]>(getUrl, body)
  }

  download(body) {
    return this.http.post(`${this.assetUrl}/assets-mapped-report/download`, body, { observe: 'response', responseType: 'arraybuffer' })
  }
}
